import React from "react";
import { WashingMachine } from "lucide-react";

/**
 * Lavatrice (core)
 */
export default function WasherIcon({
  size = 30,
  color = "currentColor",
  strokeWidth = 2,
  ...props
}) {
  return (
    <WashingMachine
      size={size}
      color={color}
      strokeWidth={strokeWidth}
      {...props}
    />
  );
}
